import { format, isValid, parse } from "date-fns";
import { range } from "lodash-es";
import type { FC } from "react";

import { TIME_FORMAT as TIME_DISPLAY_FORMAT } from "i18n/helpers";
import { Listbox, type ListboxOption } from "mds/components/Listbox";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ChevronDownIcon } from "mds/icons";

const TIME_VALUE_FORMAT = "HH:mm";

const TIME_OPTIONS = [...range(1, 24).map((i) => `${i.toString().padStart(2, "0")}:00`), "23:59"];

// eslint-disable-next-line react-refresh/only-export-components
export const formatTimeOptionForDisplay = (hhmm: string) => {
  const parsed = parse(hhmm, TIME_VALUE_FORMAT, new Date());
  return isValid(parsed) ? format(parsed, TIME_DISPLAY_FORMAT) : hhmm;
};

const TIME_LISTBOX_ITEMS: ListboxOption[] = TIME_OPTIONS.map((option) => ({
  id: option,
  title: formatTimeOptionForDisplay(option),
}));

type TimeOptionsListboxProps = {
  selectedTime: string;
  ariaLabel: string;
  onChange: (hhmm: string) => void;
};

/** Icon-only time picker listbox, intended to overlay the trailing edge of a time text input. */
export const TimeOptionsListbox: FC<TimeOptionsListboxProps> = ({
  selectedTime,
  ariaLabel,
  onChange,
}) => (
  <Listbox
    anchorTo="bottom end"
    items={TIME_LISTBOX_ITEMS}
    selectedValue={selectedTime}
    triggerButton={
      <SquareButton
        aria-label={ariaLabel}
        className="absolute right-0.5 top-1/2 -translate-y-1/2"
        kind="ghost"
        size="s"
      >
        <ChevronDownIcon size="xs" />
      </SquareButton>
    }
    onSelectionChange={(item) => onChange(item.id)}
  />
);
